import {Command} from './Command';
import {SaveObjectsTransformAction} from '../actions';
import {ObjectTransformation, ObjectTransformationFactory} from '../common/ObjectTransformation';

export class SaveObjectsTransformCommand extends Command<SaveObjectsTransformAction> {

  private objectsTransformation: Array<ObjectTransformation> = [];

  constructor(
    private factory: ObjectTransformationFactory
  ) {
    super();
  }

  do(action: SaveObjectsTransformAction) {
    action.objects.forEach(obj => this.objectsTransformation.push(this.factory.build(obj)));
  }

  undo() {
    this.objectsTransformation.forEach(ot => ot.restoreTransformation());
  }

  dispose() {
    this.objectsTransformation.length = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/SaveObjectsTransformCommand.ts